export default "__VITE_ASSET__Cp8ig$Yu__"